import React, { Component } from 'react';
import axios from "axios";
import "../../css/main-mobile-view.css";
import Landing from './Subcomponent/landing-banner';
import Partners from './Subcomponent/academic-partners';
import CourseSection from './Subcomponent/courses';
import Courseschedule from './Subcomponent/courseschedule';
import Aboutuslearners from './Subcomponent/aboutuslearners';
import Aluminicompany from './Subcomponent/aluminicompany';
import Whyedu from './Subcomponent/whyedu';
import Advisoryinstructor from './Subcomponent/advisoryinstructor';
import { toast } from "react-toastify";
class Course extends Component {
  constructor(props) {
    super(props);
    const courses = [];
    this.state = { isLoading: false, courses };
  }

  async getAllCourses() {
    this.setState({ isLoading: true });
    axios
      .post("Sample/getCourse")
      .then((res) => {
        if (res.data.status === "200") {
          this.setState({ isLoading: false, courses: res.data.course });
          // console.log(this.state.courses);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
  render() {
    return (
      <div>
        <Landing />
        <Partners />
        <section class=" padding-default our-courses-featured" id="header">
          <CourseSection />
        </section>
        <section class="blue-belt padding-default">
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <div class="blue-box">
                <img src="/assets/images/icons/blue-box-img1.svg" class="lazyload" alt="blue-box-img1" />
                <h3>Unlock your Potential</h3>
                <p>Unlock your Potential</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="blue-box">
                <img src="/assets/images/icons/blue-box-img2.svg" class="lazyload" alt="blue-box-img2" />
                <h3>Expert teachers</h3>
                <p>Find the right instructor for you</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="blue-box">
                <img src="/assets/images/icons/blue-box-img3.svg" class="lazyload" alt="blue-box-img3" />
                <h3>Focus on target</h3>
                <p>Unlock your Potential</p>
              </div>
            </div>
          </div>
        </section>
        <Courseschedule />
        <Aboutuslearners />
        <Aluminicompany />
        <Whyedu />
        <Advisoryinstructor />

      </div>
    );
  }
}

export default Course;